/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RefreshUserSessionClientCIMDSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RefreshUserSessionClientCIMDSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RefreshUserSessionClientCIMDSecurity = {
  option1?: RefreshUserSessionClientCIMDSecurityOption1 | undefined;
  option2?: RefreshUserSessionClientCIMDSecurityOption2 | undefined;
};

export type RefreshUserSessionClientCIMDRequest = {
  /**
   * The user_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RefreshUserSessionClientCIMDSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RefreshUserSessionClientCIMDSecurityOption1$outboundSchema:
  z.ZodMiniType<
    RefreshUserSessionClientCIMDSecurityOption1$Outbound,
    RefreshUserSessionClientCIMDSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function refreshUserSessionClientCIMDSecurityOption1ToJSON(
  refreshUserSessionClientCIMDSecurityOption1:
    RefreshUserSessionClientCIMDSecurityOption1,
): string {
  return JSON.stringify(
    RefreshUserSessionClientCIMDSecurityOption1$outboundSchema.parse(
      refreshUserSessionClientCIMDSecurityOption1,
    ),
  );
}

/** @internal */
export type RefreshUserSessionClientCIMDSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RefreshUserSessionClientCIMDSecurityOption2$outboundSchema:
  z.ZodMiniType<
    RefreshUserSessionClientCIMDSecurityOption2$Outbound,
    RefreshUserSessionClientCIMDSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function refreshUserSessionClientCIMDSecurityOption2ToJSON(
  refreshUserSessionClientCIMDSecurityOption2:
    RefreshUserSessionClientCIMDSecurityOption2,
): string {
  return JSON.stringify(
    RefreshUserSessionClientCIMDSecurityOption2$outboundSchema.parse(
      refreshUserSessionClientCIMDSecurityOption2,
    ),
  );
}

/** @internal */
export type RefreshUserSessionClientCIMDSecurity$Outbound = {
  Option1?: RefreshUserSessionClientCIMDSecurityOption1$Outbound | undefined;
  Option2?: RefreshUserSessionClientCIMDSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RefreshUserSessionClientCIMDSecurity$outboundSchema: z.ZodMiniType<
  RefreshUserSessionClientCIMDSecurity$Outbound,
  RefreshUserSessionClientCIMDSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RefreshUserSessionClientCIMDSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RefreshUserSessionClientCIMDSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function refreshUserSessionClientCIMDSecurityToJSON(
  refreshUserSessionClientCIMDSecurity: RefreshUserSessionClientCIMDSecurity,
): string {
  return JSON.stringify(
    RefreshUserSessionClientCIMDSecurity$outboundSchema.parse(
      refreshUserSessionClientCIMDSecurity,
    ),
  );
}

/** @internal */
export type RefreshUserSessionClientCIMDRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RefreshUserSessionClientCIMDRequest$outboundSchema: z.ZodMiniType<
  RefreshUserSessionClientCIMDRequest$Outbound,
  RefreshUserSessionClientCIMDRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function refreshUserSessionClientCIMDRequestToJSON(
  refreshUserSessionClientCIMDRequest: RefreshUserSessionClientCIMDRequest,
): string {
  return JSON.stringify(
    RefreshUserSessionClientCIMDRequest$outboundSchema.parse(
      refreshUserSessionClientCIMDRequest,
    ),
  );
}
